export default {
  loading(state, payload) {
    state.loading = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  setConfigs(state, payload) {
    state.configs = payload;
  },
  setPusher(state, payload) {
    state.pusher = payload;
  },
  setBackdrop(state, payload) {
    state.backdrop = payload;
  },
  openMenuNav(state, payload) {
    state.menuNavOpen = payload;
  },
  setAlert(state, payload) {
    state.alert = payload;
  },
  setModalAlert(state, payload) {
    state.modalAlert = payload;
  },
  setUser(state, value){
    state.user = value;
  },
  setToken(state, token) {
    state.token = token;
  },
  setLoginResult(state, value){
    state.loginResult = value;
  },
  setChangePassword(state, value) {
    state.isChangePassword = value;
  },
  setChangeDataUser(state, value) {
    state.isChangeDataUser = value;
  },
  setChangePhone(state, value) {
    state.isChangePhone = value;
  },
  setChangeRgpd(state, value) {
    state.isChangeRgpd = value;
  },
  setPortability(state, value) {
    state.isPortability = value;
  },
  setForget(state, value) {
    state.isForget = value;
  },
  setCarteiraActive(state, value) {
    state.isCarteiraActive = value;
  },
  setTransactionActive(state, value) {
    state.isTransactionActive = value;
  },
  setAccountActive(state, value) {
    state.isAccountActive = value;
  },
};
